/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Editor_LoadingInputs */

const en_gc_editor_loading = /** @type {(inputs: Gc_Editor_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Starting your workspace…`)
};

const zh_gc_editor_loading = /** @type {(inputs: Gc_Editor_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在启动工作区…`)
};

/**
* | output |
* | --- |
* | "Starting your workspace…" |
*
* @param {Gc_Editor_LoadingInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_editor_loading = /** @type {((inputs?: Gc_Editor_LoadingInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Editor_LoadingInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_editor_loading(inputs)
	return zh_gc_editor_loading(inputs)
});
export { gc_editor_loading as "gc.editor.loading" }